var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.authorized
    ? _c(
        "div",
        [
          _c("h1", {
            staticClass: "wk_headline",
            domProps: { textContent: _vm._s(_vm.translationKeywords.users) },
          }),
          _vm._v(" "),
          _c(
            "DxDataGrid",
            {
              attrs: {
                id: "gridContainer",
                "data-source": _vm.usersDataSource,
                "show-borders": true,
                "key-expr": "ID",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "user-detail-template",
                    fn: function ({ data }) {
                      return [
                        _c(
                          "DxButton",
                          {
                            staticClass: "user-detail-btn",
                            on: {
                              click: function ($event) {
                                return _vm.openInNewTab(data.key)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-eye" })]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1598472072
              ),
            },
            [
              _c("DxScrolling", { attrs: { "row-rendering-mode": "virtual" } }),
              _vm._v(" "),
              _c("DxSearchPanel", { attrs: { visible: true } }),
              _vm._v(" "),
              _c("DxPaging", { attrs: { "page-size": 10 } }),
              _vm._v(" "),
              _c("DxPager", {
                attrs: {
                  visible: true,
                  "allowed-page-sizes": _vm.pageSizes,
                  "display-mode": _vm.displayMode,
                  "show-page-size-selector": _vm.showPageSizeSelector,
                  "show-info": _vm.showInfo,
                  "show-navigation-buttons": _vm.showNavButtons,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "firstName",
                  caption: _vm.translationKeywords.firstName,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "lastName",
                  caption: _vm.translationKeywords.lastName,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "userName",
                  caption: _vm.translationKeywords.userName,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "email",
                  caption: _vm.translationKeywords.mailAddress,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "companyName",
                  caption: _vm.translationKeywords.companyName,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "departmentName",
                  caption: _vm.translationKeywords.department,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "data-field": "costCenter",
                  caption: _vm.translationKeywords.costCenter,
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "cell-template": "user-detail-template",
                  "data-field": "userDetail",
                  caption: _vm.translationKeywords.userDetail,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }